module.exports = __webpack_public_path__ + "static/media/slideshow-26.e01de951.jpeg";